module.exports = __webpack_public_path__ + "img/awards_image_24.04cee411.png";